/**
 * Created by hp on 2017/7/16.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormCell, CellBody, CellFooter} from 'react-weui';
import {WKBottomSheet} from '../../components';
import Config from '../../config';
import '../../styles/lecture/LectureGiftSheet.css';
import {renderMoney} from '../../utils';

class LectureGiftSheet extends Component {
    constructor() {
        super();
        this.state = {
            lecturePrice: 0
        };
        this.handleClose = this.handleClose.bind(this);
        this.handlePayGift = this.handlePayGift.bind(this);
        this.handlePlus = this.handlePlus.bind(this);
        this.handleSub = this.handleSub.bind(this);
        this.handleChangeNum = this.handleChangeNum.bind(this);
    }

    handleChangeNum(e) {
        let num = e.target.value;
        let money = this.props.money;
        this.setState({
            lecturePrice: num * money
        });
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: num
            }
        });
    }

    handlePlus() {
        let giftNum = this.props.giftNum;
        let money = this.props.money;
        this.setState({
            lecturePrice: (giftNum + 1) * money
        });
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: this.props.giftNum + 1
            }
        })
    }

    handleSub() {
        let giftNum = this.props.giftNum === 1 ? 1 : (this.props.giftNum - 1);
        let money = this.props.money;
        this.setState({
            lecturePrice: (giftNum * money),
        });
        this.props.dispatch({
            type: 'LECTURE_SET_GIFT_NUM',
            payload: {
                giftNum: giftNum
            }
        })
    }

    handleClose() {
        this.props.dispatch({
            type: 'LECTURE_HIDE_GIFT_BAR'
        });

        this.setState({
            lecturePrice: 0,
        });
    }

    handlePayGift() {
        let {lectureId, giftNum} = this.props;
        this.props.dispatch({
            type: 'PAY_LECTURE',
            payload: {
                params: {
                    product: 'gift_lecture',
                    gift_count: giftNum,
                    lecture_id: lectureId,
                },
                success: () => {
                    this.props.dispatch({
                        type: 'LECTURE_HIDE_GIFT_BAR'
                    });
                    this.props.dispatch({
                        type: 'MTA_CLICK',
                        payload: 'lecture_giftpayfinish'
                    });
                    window.location = Config.MAIN_URL + `/lecture/pay_success?lecture_id=${lectureId}&st=pay_gift_lecture`;
                }
            }
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_giftpay'
        })
    }

    render() {
        const {lectureTitle, giftNum, money, showGiftBar} = this.props;
        return (
            <div className="lecture-gift-sheet">
                {showGiftBar &&
                <WKBottomSheet
                    text="赠送"
                    handleClose={this.handleClose}
                    handleSubmit={this.handlePayGift}>
                    <div className="lecture-gift-title">
                        <span className="lecture-gift-tag">单课</span>
                        <span className="lecture-gift-tag-title">{lectureTitle}</span>
                    </div>

                    <FormCell>
                        <CellBody><span className="lecture-gift-zs">赠送数量</span></CellBody>
                        <CellFooter>
                            <div className="lecture-gift-num">
                                <span onClick={this.handleSub}
                                      className="lecture-gift-num-btn lecture-gift-num-left">－</span>
                                <span className="lecture-gift-num-content">
                                    <input pattern="[0-9]*" type="number" value={giftNum} min="1" onChange={this.handleChangeNum}/>
                                </span>
                                <span onClick={this.handlePlus} className="lecture-gift-num-btn lecture-gift-num-right">＋</span>
                            </div>
                        </CellFooter>
                    </FormCell>

                    <FormCell>
                        <CellBody><span className="lecture-gift-zs">总金额</span></CellBody>
                        <CellFooter>
                            <span className="lecture-gift-zs money">
                                ￥{this.state.lecturePrice ? renderMoney(this.state.lecturePrice) : renderMoney(money)}
                            </span>
                        </CellFooter>
                    </FormCell>
                </WKBottomSheet>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    lectureId: state.lecture.lecture.id,
    lectureTitle: state.lecture.lecture.name,
    giftNum: state.lecture.giftNum,
    showGiftBar: state.lecture.showGiftBar,
    money: state.lecture.lecture.limit_money ? state.lecture.lecture.limit_money.money : state.lecture.lecture.money,
}))(LectureGiftSheet)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureGiftSheet.js